import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

console.log("SUPABASE URL:", supabaseUrl);
console.log("SUPABASE ANON KEY exists:", !!supabaseAnonKey);

if (!supabaseUrl) {
    throw new Error("REACT_APP_SUPABASE_URL is missing");
}

if (!supabaseAnonKey) {
    throw new Error("REACT_APP_SUPABASE_ANON_KEY is missing");
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);